var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeposit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "84px",
    height: "84px",
    viewBox: "0 0 84 84",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "telegram\u5907\u4EFD 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iPhone-13\\u5907\\u4EFD",
    transform: "translate(-245.000000, -194.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "telegram\\u5907\\u4EFD-2",
    transform: "translate(245.000000, 194.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0,
    y: 0,
    width: 84,
    height: 84
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#3A843B",
    x: 14,
    y: 14,
    width: 56,
    height: 56,
    rx: 10.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7333137,45.885 L59.3959185,57.6516144 C59.4502554,58.616584 58.7120416,59.4428953 57.7470719,59.4972322 C57.7143092,59.499077 57.681501,59.5 57.6486863,59.5 L26.3513137,59.5 C25.3848154,59.5 24.6013137,58.7164983 24.6013137,57.75 C24.6013137,57.7171853 24.6022367,57.6843771 24.6040815,57.6516144 L25.2663137,45.887 L42,54.3344844 L42,54.304907 L58.7333137,45.885 Z M56.6632714,38.5 C57.5915476,38.5 58.3583156,39.2248064 58.4105036,40.1516144 L58.5413137,42.481 L42,50.804907 L42,50.8344844 L25.4583137,42.482 L25.5894964,40.1516144 C25.6416844,39.2248064 26.4084524,38.5 27.3367286,38.5 L56.6632714,38.5 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,24.5 L42,38.5 M35,31.5 L41.9915473,38.5 M48.9915473,31.5 L42,38.5",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    stroke: "#FFFFFF",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit);
export default __webpack_public_path__ + "static/media/deposit.d7a3e44324032bd3591a521ff2852130.svg";
export { ForwardRef as ReactComponent };